<template>
    <div>保险详情</div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        methods:{

        }
    }
</script>
<style lang="less" scoped>

</style>
